import Vue from 'vue';

export const userKey = '__knowledge_user';
export const passportTokenKey = '__knowledge_token';
export const localStorageKey = '__knowledge_ls_version';
export const baseApiUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_API_URL_STAGING
    : process.env.VUE_APP_API_URL;
export const externalApiUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_EXTERNAL_API_STAGING
    : process.env.VUE_APP_EXTERNAL_API;
export const XAPIKey = process.env.VUE_APP_X_API_KEY;
export const jwtKey = process.env.VUE_APP_JWT_KEY;
export const localStorageVersion = process.env.VUE_APP_LOCAL_STORAGE_VERSION;

export function showError(e) {
  if (e && e.response && e.response.data) {
    Vue.toasted.error(e.response.data.error, {
      duration: 3000,
      position: 'bottom-right',
      className: 'alertError',
    });
  } else if (typeof e === 'string') {
    Vue.toasted.error(e, {
      duration: 3000,
      position: 'bottom-right',
      className: 'alertError',
    });
  } else {
    Vue.toasted.error('Ocorreu um erro.', {
      duration: 3000,
      position: 'bottom-right',
      className: 'alertError',
    });
  }
}

export default { baseApiUrl, externalApiUrl, showError, userKey };
